import { Fragment } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { toastr } from 'react-redux-toastr';

import Layout from 'components/layout';
import Table from 'components/table';
import Time from 'components/time';
import Releases from 'endpoints/releases';
import Guard, { hasPermissionFor } from 'components/guard';
import DownloadBtn from 'components/download-btn';
import Wait from 'components/wait';

const HEADERS = [
  [20, 'published_at', (a, b) => a.createdAt - b.createdAt],
  [20, 'release_version', (a, b) => a.id - b.id],
  [20, 'creator', (a, b) => a.creatorName.localeCompare(b.creatorName)],
  [15, 'status', (a, b) => a.status.localeCompare(b.status)],
  [15, 'app_update', () => {}],
];

const ActionButtons = ({ release, ids, makeDefaultRelease }) => {
  if (ids === null) {
    return (
      <Fragment>
        {release.showRefreshIcon && (
          <Guard key="def" permission="DB_RELEASE" level="exec">
            <a
              href="#"
              onClick={() => makeDefaultRelease(release)}
              className="fa fa-undo"
            />
          </Guard>
        )}
        <DownloadBtn
          key="download"
          type="release"
          id={release.id}
          className="fa fa-download"
          link
        />
      </Fragment>
    );
  }

  if (release.isArchive) {
    return (
      <span
        className={`fa fa-${
          ids.includes(release.id) ? 'check-square-o' : 'square-o'
        }`}
      />
    );
  }

  return null;
};

export default class extends React.Component {
  constructor() {
    super();
    this.onDelete = this.onDelete.bind(this);
    this.renderRow = this.renderRow.bind(this);
    this.state = { releases: null, ajax: false };
  }

  componentDidMount() {
    Releases.getList().then((releases) => this.setState({ releases }));
  }

  onDelete(ids) {
    return Releases.del(ids.join(',')).then(() => {
      let releases = this.state.releases.filter((r) => !ids.includes(r.id));
      this.setState({ releases });
    });
  }

  makeDefaultRelease = (release) => {
    toastr.confirm(I18n.t('releases.confirm_default'), {
      onOk: () => {
        this.setState({ ajax: true });
        Releases.makeDefault(release.id).then(
          () => {
            let releases = this.state.releases.map((item) => {
              let isArchive, status;
              if (item.id === release.id) {
                isArchive = false;
                status = 'RELEASE';
              } else {
                isArchive = true;
                status = 'ARCHIVED';
              }
              return { ...item, isArchive, status };
            });
            this.setState({ releases, ajax: false });
          },
          () => this.setState({ ajax: false })
        );
      },
    });
  }

  renderRow(release, ids, onSelect) {
    const handleClick = ids === null ? null : release.isArchive ? onSelect : null;

    return (
      <tr
        key={release.id}
        onClick={handleClick}
        className={`table_row ${handleClick ? 'table_row--link' : ''}`}
      >
        <td>
          <Time value={release.createdAt} />
        </td>
        <td>{release.id}</td>
        <td>{release.creatorName}</td>
        <td>
          <label
            className={`release-status release-status--${release.status.toLowerCase()}`}
          >
            <Translate
              value={`enums.release_status.${release.status.toLowerCase()}`}
            />
          </label>
        </td>
        <td>
          {release.application_update !== 'none' ? release.application_update : ''}
        </td>
        <td className="table_row_actions">
          <ActionButtons release={release} ids={ids} makeDefaultRelease={this.makeDefaultRelease} />
        </td>
      </tr>
    );
  }

  render() {
    const { releases } = this.state;
    const isLoading = releases === null || this.state.ajax;

    return (
      <Layout>
        {isLoading ? (
          <Wait />
        ) : (
          <Table
            headers={HEADERS}
            renderRow={this.renderRow}
            list={releases}
            title="releases.title"
            onDelete={
              hasPermissionFor('DB_RELEASE', 'exec') ? this.onDelete : null
            }
            sortingBack
          />
        )}
      </Layout>
    );
  }
}
